module.exports = __webpack_public_path__ + "img/1.1a34caf3.jpg";